import { Routes } from "@angular/router";
import { AuthGuard } from "./core/guards/auth.guard";
import { ENROLLMENT_SHARED_USER_TYPES } from "./core/constants/shared.access";
import { HoldRestrictionGuard } from "./core/guards/hold-restriction.guard";

export const enrollmentPaymentPageRoute: Routes = [
  {
    path: "enrollment-payment",
    canActivate: [AuthGuard, HoldRestrictionGuard],
    data: { userTypes: ENROLLMENT_SHARED_USER_TYPES, moduleId: "payments" },
    loadComponent: () =>
      import("./student-dashboard/enrollment/enrollment-payment-page/enrollment-payment-page.component").then(
        (m) => m.EnrollmentPaymentPageComponent,
      ),
  },
];
